import Vue from 'vue';
import BaseApi from './baseApi.js';

function getUserIP(onNewIP) { //  onNewIp - your listener function for new IPs
    //compatibility for firefox and chrome
    var myPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection;
    var pc = new myPeerConnection({
            iceServers: []
        }),
        noop = function () {},
        localIPs = {},
        ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g,
        key;

    function iterateIP(ip) {
        if (!localIPs[ip]) onNewIP(ip);
        localIPs[ip] = true;
    }

    //create a bogus data channel
    pc.createDataChannel("");

    // create offer and set local description
    pc.createOffer().then(function (sdp) {
        sdp.sdp.split('\n').forEach(function (line) {
            if (line.indexOf('candidate') < 0) return;
            line.match(ipRegex).forEach(iterateIP);
        });

        pc.setLocalDescription(sdp, noop, noop);
    }).catch(function (reason) {
        // An error occurred, so handle the failure to connect
    });

    //sten for candidate events
    pc.onicecandidate = function (ice) {
        if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return;
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
    };
}

// Usage
export default class Util {
    constructor() {
        throw new Error('静态类不需要初始化');
    }
    static getLocation = function (callback, errCallback) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                let latitude = position.coords.latitude
                let longitude = position.coords.longitude
                let geocoder = new qq.maps.Geocoder({
                    complete: function (result) {
                        callback && callback(result);
                    }
                });
                var coord = new qq.maps.LatLng(latitude, longitude);
                geocoder.getAddress(coord);
            }, errCallback || function (error) {
                callback && callback(null);
                switch (error.code) {
                    case 1:
                        //console.log("位置服务被拒绝。");
                        break;
                    case 2:
                        //console.log("暂时获取不到位置信息。");
                        break;
                    case 3:
                        //console.log("获取位置信息超时。");
                        break;
                    default:
                        //console.log("未知错误。");
                        break;
                }
            });
        } else {
            return null;
        }
    }
    static getLocationByIp() {
        getUserIP((ip) => {
            BaseApi.createRpcToken("/getLocationByIp", {
                key: 'ZQXBZ-ZTIKQ-VF753-GW4PJ-HWZHV-UQFO3',
                ip: ip
            }).then(
                data => {
                    this.signPersonList = data.datas.list;
                },
                err => {}
            ).catch(function (e) {
                errorLog(e);
            });
        })

    }
    // 获取唯一值
    static getUID = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    static compareTime(startDate, endDate, stratType = 'string', endType = 'string') {
        if (startDate && endDate) {
            var allStartDate = '';
            var allEndDate = '';
            if (stratType == 'string') {
                var startDateTemp = startDate.split(" ");
                var arrStartDate = startDateTemp[0].split("-");
                if(startDateTemp[1]){
                    var arrStartTime = startDateTemp[1].split(":");
                    allStartDate = new Date(arrStartDate[0], arrStartDate[1] - 1, arrStartDate[2], arrStartTime[0], arrStartTime[1], arrStartTime[2]);
                }else{
                    // var arrStartTime = startDateTemp[1].split(":");
                    allStartDate = new Date(arrStartDate[0], arrStartDate[1] - 1, arrStartDate[2]);
                }
            } else {
                allStartDate = startDate;
            }
            if (endType == 'string') {
                var endDateTemp = endDate.split(" ");
                var arrEndDate = endDateTemp[0].split("-");
                if(endDateTemp[1]){
                    var arrEndTime = endDateTemp[1].split(":");
                    allEndDate = new Date(arrEndDate[0], arrEndDate[1] - 1, arrEndDate[2], arrEndTime[0], arrEndTime[1], arrEndTime[2]);
                }else{
                    allEndDate = new Date(arrEndDate[0], arrEndDate[1] - 1, arrEndDate[2]);
                }
                
            } else {
                allEndDate = endDate;
            }
            if (allStartDate.getTime() >= allEndDate.getTime()) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    }
    static getNowDate() {
        var time = new Date();
        var year = time.getFullYear(); //获取年
        var month = time.getMonth() + 1; //或者月
        var day = time.getDate(); //或者天
        var hour = time.getHours(); //获取小时
        var minu = time.getMinutes(); //获取分钟
        var second = time.getSeconds(); //或者秒
        return `${year}-${month}-${day}  ${hour}:${minu}:${second}`
    }
    static compareTimeToNow(startDate, returnType = 'boolean') {
        if (startDate.length > 0) {
            var startDateTemp = startDate.split(" ");
            var arrStartDate = startDateTemp[0].split("-");
            var arrStartTime = startDateTemp[1].split(":");
            var allStartDate = new Date(arrStartDate[0], arrStartDate[1] - 1, arrStartDate[2], arrStartTime[0], arrStartTime[1], arrStartTime[2]);
            var time = new Date();
            var year = time.getFullYear(); //获取年
            var month = time.getMonth(); //或者月
            var day = time.getDate(); //或者天
            var hour = time.getHours(); //获取小时
            var minu = time.getMinutes(); //获取分钟
            var second = time.getSeconds(); //或者秒
            var allEndDate = new Date(year, month, day, hour, minu, second);
            if (allStartDate.getTime() >= allEndDate.getTime()) {
                if (returnType == 'boolean') {
                    return true;
                } else {
                    return allStartDate;
                }

            } else {
                if (returnType == 'boolean') {
                    return false;
                } else {
                    return allEndDate;
                }
            }
        } else {
            return false;
        }
    }
}